module.exports = __webpack_public_path__ + "static/media/h02.0f7bc103.webp";